export interface Point2 {
  x: number;
  y: number;
}

/** Liang–Barsky: 線分と軸平行矩形の交差部分（空なら null） */
export function clipLineSegmentToRect(
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  xmin: number,
  ymin: number,
  xmax: number,
  ymax: number
): { x0: number; y0: number; x1: number; y1: number } | null {
  const dx = x1 - x0;
  const dy = y1 - y0;
  const p = [-dx, dx, -dy, dy];
  const q = [x0 - xmin, xmax - x0, y0 - ymin, ymax - y0];
  let u1 = 0;
  let u2 = 1;
  for (let i = 0; i < 4; i++) {
    const pi = p[i]!;
    const qi = q[i]!;
    if (pi === 0) {
      if (qi < 0) return null;
    } else {
      const r = qi / pi;
      if (pi < 0) u1 = Math.max(u1, r);
      else u2 = Math.min(u2, r);
    }
  }
  if (u1 > u2) return null;
  return {
    x0: x0 + u1 * dx,
    y0: y0 + u1 * dy,
    x1: x0 + u2 * dx,
    y1: y0 + u2 * dy,
  };
}

const JOIN_EPS = 1e-3;

/** 折れ線を矩形内にクリップし、複数の連続片を 1 つの path d（M/L）にする */
export function clippedPolylinePathD(points: Point2[], width: number, height: number): string {
  if (points.length < 2) return '';
  const parts: string[] = [];
  let lastX: number | null = null;
  let lastY: number | null = null;

  for (let i = 0; i < points.length - 1; i++) {
    const a = points[i]!;
    const b = points[i + 1]!;
    const seg = clipLineSegmentToRect(a.x, a.y, b.x, b.y, 0, 0, width, height);
    if (!seg) continue;
    const { x0: sx, y0: sy, x1: ex, y1: ey } = seg;
    const jump =
      lastX === null ||
      lastY === null ||
      Math.hypot(sx - lastX, sy - lastY) > JOIN_EPS;
    if (jump) {
      parts.push(`M ${sx} ${sy} L ${ex} ${ey}`);
    } else {
      parts.push(`L ${ex} ${ey}`);
    }
    lastX = ex;
    lastY = ey;
  }
  return parts.join(' ');
}
